<template lang="pug">
v-container.pa-0(grid-list-xl, fluid)
  v-layout(wrap)
    v-flex(xs12)
      v-text-field(
        v-model='block.meta.display.name',
        label='Название',
        @input='$emit("update", block)'
      )
    v-flex(xs12)
      .mb-2
        v-label Галерея
      .mb-4(v-if='block.value.length > 0')
        v-container.pa-0(
          v-sortable=`{
            handler: '.handler',
            container: '.layout',
            callback: onSorted
          }`,
          fluid
        )
          v-layout(:class={ "row wrap": true }, style={ "margin-top": 0 })
            slot(v-for='(v, k) in block.value', :item='v', name='item')
              v-flex.with-pointer(xs12, sm4)
                v-card.handler.d-flex(:data-index='k', flat)
                  v-img.grey.lighten-4(
                    :src='v.url',
                    aspect-ratio='1',
                    :lazy-src='v.url'
                  )
                    v-layout(
                      slot='placeholder',
                      fill-height,
                      align-center,
                      justify-center,
                      ma-0
                    )
                      v-progress-circular(indeterminate, color='primary')
                  .controls.pa-2(@click.stop)
                    v-spacer
                    v-btn(@click='removeFile(k)', icon)
                      v-icon delete_outline
                    v-btn(@click='openDialog(k)', icon)
                      v-icon edit
      div
        form(ref='form')
          .files
            input.upload(type='file', @change='prepareFiles', multiple)
            .hint Нажмите или перенесите файлы сюда
  v-dialog(v-model='busy', persistent, width='280')
    v-card(color='primary', dark)
      v-card-text Загрузка файла
      v-progress-linear.mb-0(:indeterminate='true', color='white')
  v-dialog(v-model='editDialog', width='280')
    v-card
      v-form(@submit='closeDialog')
        .pa-3(v-if='editIndex !== null')
          v-text-field(
            label='Название',
            v-model='block.value[editIndex].name',
            @input='$emit("update", block)'
          )
</template>

<script>
import http from '@/http'
import BaseBlock from './BaseBlock'

export default {
  extends: BaseBlock,

  data: function () {
    return {
      uploadCounter: 0,
      editDialog: false,
      editIndex: null,
    }
  },

  methods: {
    closeDialog(ev) {
      ev.preventDefault()
      this.editIndex = null
      this.editDialog = false
    },

    openDialog(index) {
      this.editIndex = index
      this.editDialog = true
    },

    insertFile(file) {
      this.block.value.push(file)
      this.$emit('update', this.block)
    },

    async removeFile(index) {
      if (await this.$confirm('Вы уверены?')) {
        const file = this.block.value[index]

        http.post('files/delete', { hash: file.hash })

        this.block.value.splice(index, 1)
        this.$emit('update', this.block)
      }
    },

    prepareFiles(ev) {
      for (const file of ev.target.files) {
        if (file && file.type.match(/image.*/)) {
          this.uploadCounter++
          this.upload(file)
        } else {
          this.$root.showSnack('Неподдерживаемый формат файла')
        }
      }
    },

    onSorted() {
      const indexes = [...this.$el.querySelectorAll('[data-index]')]
        .map((element) => element.getAttribute('data-index'))
        .map((index) => +index)

      const prevValue = [...this.block.value]
      this.block.value = []

      this.$nextTick(() => {
        const sorted = indexes.map((index) => prevValue[index])
        this.block.value = sorted
      })
    },

    async upload(file) {
      const formdata = new FormData()
      const ext = file.name.split('.').pop()
      formdata.append('blockeditor', file, `attach.${ext}`)
      try {
        const res = await http.post('/files/upload/blockeditor', formdata)
        this.insertFile(res.data)
      } catch (error) {
        this.$root.showSnack('Ошибка загрузки файла')
      } finally {
        this.uploadCounter--
      }
    },
  },

  computed: {
    busy() {
      return this.uploadCounter > 0
    },
  },

  watch: {
    uploadCounter(count) {
      if (count <= 0) {
        this.$refs.form.reset()
      }
    },
    editDialog(opened) {
      if (!opened) {
        this.editIndex = null
      }
    },
  },
}
</script>

<style scoped>
.files {
  position: relative;
  border: solid 1px #ccc;
  min-height: 80px;
  overflow: hidden;
}
.upload {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: absolute;
  opacity: 0;
  cursor: pointer;
  font-size: 100px;
}
.hint {
  pointer-events: none;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.toolbar {
  z-index: 10;
}
.preview {
  padding: 64px;
}
.controls {
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 2;
  position: absolute !important;
  background: white;
  display: flex;
  align-items: flex-end;
  height: 50px;
}
.controls .v-btn {
  margin: 0;
  margin-left: 8px;
}
.handler {
  cursor: move;
  border-radius: 0;
  border: solid 1px #ccc;
  overflow: hidden;
}
.handler >>> .v-image__image--cover {
  bottom: 50px;
  height: unset;
  background-size: contain !important;
  background-position: center !important;
}
</style>
